import React, { useCallback } from 'react';
import { CustomerServiceOutlined } from '@ant-design/icons';
import { motion } from 'framer-motion';
import { Tooltip } from 'antd';
import { SupportTicketModal } from './support/SupportTicketModal';
import { useSupportModalStore } from '../../stores/useSupportModalStore';

interface SupportButtonProps {
  className?: string;
}

export const SupportButton: React.FC<SupportButtonProps> = ({
  className = '',
}) => {
  const { isOpen, errorContext, openClean, close } = useSupportModalStore();

  const handleOpen = useCallback(() => openClean(), [openClean]);
  const handleClose = useCallback(() => close(), [close]);

  return (
    <>
      <Tooltip title="Поддержка" placement="bottom">
        <motion.button
          className={`header-button support-button ${className}`}
          onClick={handleOpen}
          title="Поддержка"
          data-tour-id="support-button"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
        >
          <CustomerServiceOutlined style={{ fontSize: 18, color: 'white' }} />
        </motion.button>
      </Tooltip>

      <SupportTicketModal
        open={isOpen}
        onClose={handleClose}
        initialValues={errorContext}
      />
    </>
  );
};
